const menuText = {
  title: "90 Day Haiku",
  playIndication: "Press ENTER or TAP anywhere to Start the Game",
};

export default menuText;




